import GemMeterBaseRule from '../GemMeterBaseRule';
import { NO_SOURCE_VIDEO } from '../../../constants/rulesConstants';

export default class MissingVideoBgLinkRule extends GemMeterBaseRule {
  static ruleId = NO_SOURCE_VIDEO.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return true;
    }

    const { videoSource, urlYoutube, urlVimeo, urlCustom } = (element as HTMLElement).dataset;

    return (
      !!(
        videoSource === 'youtube'
        && urlYoutube
        && urlYoutube.trim().length > 0
      ) ||
      !!(
        videoSource === 'vimeo'
        && urlVimeo
        && !urlVimeo.includes('data-url-custom=') && urlVimeo.trim().length > 0
      ) ||
      !!(
        videoSource === 'custom'
        && (
          (
            urlCustom
            && !urlCustom.includes('data-image=')
            && urlCustom.trim().length > 0
          )
          || (
            urlVimeo
            && urlVimeo.includes('data-url-custom=')
            && urlVimeo.trim().length > 16
          )
        )
      )
    );
  }
}
